import React from 'react';
import { MapPin, GraduationCap, Award } from 'lucide-react';
import { personalInfo, education, certifications } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <span className="label-text text-[rgba(35,35,35,0.5)] mb-4 block">About Me</span>
          <h2 className="section-title">Who I Am</h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Bio */}
          <div>
            <p className="font-body text-lg lg:text-xl text-[rgba(35,35,35,0.8)] leading-relaxed mb-8">
              {personalInfo.bio}
            </p>
            
            <div className="flex items-center gap-2 text-[rgba(35,35,35,0.6)]">
              <MapPin className="w-4 h-4" />
              <span className="font-mono text-sm">{personalInfo.location}</span>
            </div>
          </div>

          {/* Education & Certification Cards */}
          <div className="space-y-6">
            {/* Education Card */}
            <div className="card-sharp p-6">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-[#38FF62]">
                  <GraduationCap className="w-6 h-6 text-[#232323]" />
                </div>
                <div>
                  <span className="label-text text-[rgba(35,35,35,0.5)] text-[10px] block mb-2">Education</span>
                  <h3 className="font-display font-semibold text-lg mb-1">{education.degree}</h3>
                  <p className="font-body text-[rgba(35,35,35,0.7)]">{education.institution}</p>
                  <p className="font-mono text-xs text-[rgba(35,35,35,0.5)] mt-2">{education.duration}</p>
                </div>
              </div>
            </div>

            {/* Certification Card */}
            {certifications.map((cert) => (
              <div key={cert.id} className="card-sharp p-6">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-[#232323]">
                    <Award className="w-6 h-6 text-[#38FF62]" />
                  </div>
                  <div>
                    <span className="label-text text-[rgba(35,35,35,0.5)] text-[10px] block mb-2">Certification</span>
                    <h3 className="font-display font-semibold text-lg mb-1">{cert.name}</h3>
                    <p className="font-body text-[rgba(35,35,35,0.7)]">{cert.credential}</p>
                    <p className="font-mono text-xs text-[rgba(35,35,35,0.5)] mt-2">{cert.issuer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;